import { render, staticRenderFns } from "./_betListTG.vue?vue&type=template&id=2225c8a9&lang=pug&"
import script from "./_betListTG.vue?vue&type=script&lang=js&"
export * from "./_betListTG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports